/* eslint-disable */
import ClipboardJS from 'clipboard';
import { inject } from 'vue';

let cp;
export default function useCopy() {
  const $message = inject('$message')
  let inp = window._copyButton_;
  if (!inp) {
    inp = window._copyButton_ = document.createElement('button');
    inp.style.position = 'absolute';
    inp.style.left = '-100000px';
    inp.style.zIndex = '-1000';
    inp.classList.add('cp-button');
    inp.innerText = 'copy';
    document.body.appendChild(inp);
  }
  if (!cp) {
    cp = new ClipboardJS('.cp-button');
    cp.on('success', () => {
      $message.success('已复制')
    });
  }
  return (content) => {
    inp.setAttribute('data-clipboard-text', content);
    setTimeout(() => {
      window._copyButton_.click();
    }, 10);
  }
}
